/**
 * Main Routes
 *
 * Dashboard and personal settings routes, plus aggregation of every
 * feature area's routes (questions/evaluations/flags/reports/tenant) and
 * dynamically registered module routes.
 *
 * Titles/descriptions/breadcrumbs are auto-resolved by the i18n router
 * guard from each route's `name` — see `src/plugins/i18n/routeI18n.ts`.
 */

import {
  questionRoutes,
  evaluationRoutes,
  flagRoutes,
  reportRoutes,
  tenantRoutes
} from './routes'
import { getAllModuleRoutes } from '../../modules'

// Dashboard and personal settings routes
const coreRoutes = [
  {
    path: '',
    name: 'core.dashboard',
    component: () => import('../pages/dashboard/BackendHome.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: 'personalSettings',
    name: 'core.personalSettings',
    component: () => import('../pages/settings/user/SettingsView.vue'),
    meta: { requiresAuth: true }
  }
]

// Combine all routes (module routes are dynamically loaded from the module registry)
export default [
  ...coreRoutes,
  ...questionRoutes,
  ...evaluationRoutes,
  ...flagRoutes,
  ...reportRoutes,
  ...tenantRoutes,
  ...getAllModuleRoutes()
]
